import { isNil } from 'mojito/utils';
import MojitoCore from 'mojito/core';
import AbsolutePane from 'presentation/components/absolute-pane/index.js';
import Arrowhead from 'presentation/components/arrowhead/index.js';
import HideablePane from 'presentation/components/hideable-pane/index.js';
import PriceChangeIndicatorTypes from './types.js';

const classUtils = MojitoCore.Base.classUtils;
const { PRICE_CHANGE_STATES } = PriceChangeIndicatorTypes;

const PriceChangeIndicator = ({ oldPrice, newPrice, mojitoTools, class: className }) => {
    const { config, style } = mojitoTools;

    const direction = (() => {
        if (isNil(oldPrice) || isNil(newPrice)) {
            return PRICE_CHANGE_STATES.NONE;
        }
        if (priceIsHigher(oldPrice, newPrice)) {
            return PRICE_CHANGE_STATES.INCREASE;
        }
        if (priceIsHigher(newPrice, oldPrice)) {
            return PRICE_CHANGE_STATES.DECREASE;
        }
        return PRICE_CHANGE_STATES.NONE;
    })();

    const { INCREASE, DECREASE, NONE } = PRICE_CHANGE_STATES;
    const priceDirections = {
        [INCREASE]: {
            arrowConfig: config.arrowheadUp,
            paneConfig: config.transition,
        },
        [DECREASE]: {
            arrowConfig: config.arrowheadDown,
            paneConfig: style.hidePaneDown,
        },
        [NONE]: null,
    }[direction];

    if (!priceDirections) {
        return null;
    }

    const { arrowConfig, paneConfig } = priceDirections;

    return (
        <AbsolutePane
            config={style.container}
            class={classUtils.classNames('ta-PriceChangeIndicator', className)}
        >
            <HideablePane config={paneConfig}>
                <Arrowhead config={arrowConfig} />
            </HideablePane>
        </AbsolutePane>
    );
};

PriceChangeIndicator.getStyle = (config, mode, merge) => ({
    container: config.container,
    hidePaneDown: merge(config.transition, {
        style: {
            base: {
                alignItems: 'flex-end',
            },
        },
    }),
});

function toNumericPrice(value) {
    if (isNil(value)) {
        return NaN;
    }
    if (typeof value === 'number') {
        return Number.isNaN(value) ? NaN : value;
    }
    if (typeof value === 'string') {
        return Number.parseFloat(value);
    }
    return NaN;
}

function priceIsHigher(refPrice, testPrice) {
    const ref = toNumericPrice(refPrice);
    const test = toNumericPrice(testPrice);
    if (Number.isNaN(ref) || Number.isNaN(test)) {
        return false;
    }
    return test > ref;
}

export default PriceChangeIndicator;
